import React from "react";
import PropTypes from "prop-types";
import { Modal, Box, Typography, Button } from "@mui/material";

export const LogDetailModal = ({
  open,
  onClose,
  log,
  transformFecha,
  transformHora,
}) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "90vw",
          maxWidth: 600,
          maxHeight: "80vh",
          overflowY: "auto",
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
        }}
      >
        {log && (
          <>
            <Typography sx={{ mt: 1, wordBreak: "break-word" }}>
              <strong>Fuente:</strong> {log.source}
            </Typography>
            <Typography sx={{ mt: 1, wordBreak: "break-word" }}>
              <strong>Fecha:</strong> {transformFecha(log.timestamp)}
            </Typography>
            <Typography sx={{ mt: 1, wordBreak: "break-word" }}>
              <strong>Hora:</strong> {transformHora(log.timestamp)}
            </Typography>
            <Typography sx={{ mt: 1, wordBreak: "break-word" }}>
              <strong>Mensaje:</strong> {log.message}
            </Typography>
            <Typography sx={{ mt: 1, wordBreak: "break-word" }}>
              <strong>Excepción:</strong> {log.exception || "N/A"}
            </Typography>
            <Typography sx={{ mt: 1, wordBreak: "break-word" }}>
              <strong>Nivel:</strong> {log.logLevel}
            </Typography>
            <Box sx={{ mt: 3, display: "flex", justifyContent: "flex-end" }}>
              <Button onClick={onClose} variant="contained" color="primary">
                Cerrar
              </Button>
            </Box>
          </>
        )}
      </Box>
    </Modal>
  );
};

LogDetailModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  log: PropTypes.object,
};